import React from "react";

import TermOfServicePreview from "../TermOfServicePreview";
import PrivacyCustomerPreview from "../PrivacyCustomerPreview";
import { RegisterUser } from "../../../apis/UserSessionAPI";
import TextLineInput from "../../../ui-components/TextLineInput";
import EmailInput from "../../../ui-components/EmailInput";
import PasswordInput from "../../../ui-components/PasswordInput";
import SubmitButton from "../../../ui-components/SubmitButton";
import CheckBoxInput from "../../../ui-components/CheckBoxInput";

import { registerSignupToFacebook } from "../../../apis/Analytics/registerOrderToFacebook";
import { sendConsentIub } from "../../../utils/consentManager";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";


async function registerConsent(user) {
  await sendConsentIub(user);
}

export default class SignUpUserForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      email_confirmation: "",
      password: "",
      password_confirmation: "",
      terms_of_service: false,
      policy: false,
      profiling: false,
      errors: {},
      inviter_referral_code: props.inviter_referral_code || "",
      showConsentModal: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.state.policy === false || this.state.profiling === false) {
    }

    const userData = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      email_confirmation: this.state.email_confirmation,
      password: this.state.password,
      password_confirmation: this.state.password_confirmation,
      terms_of_service: this.state.terms_of_service ? "1" : "0",
      consents: {
        customer_terms: this.state.terms_of_service ? "1" : "0",
        customer_marketing: this.state.marketing ? "1" : "0",
        customer_profiling: this.state.profiling ? "1" : "0"
      },
      inviter_referral_code: this.state.inviter_referral_code
    };

    RegisterUser(userData)
      .then(response => {
        if (this.props.onLogin) {
          registerSignupToFacebook();
          registerConsent(response.user_session.user);
          this.props.onLogin(response);
        }
      })
      .catch(error => {
        const errors = error.response.body.errors;

        this.setState({
          errors: errors
        });
      });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <Row>
          <Col sm={6}>
            <TextLineInput
              name="first_name"
              placeholder={I18n.t("pages.user_session.user.first_name")}
              value={this.state.first_name}
              onChange={this.handleInputChange}
              errors={this.state.errors.first_name}
            />
          </Col>
          <Col sm={6}>
            <TextLineInput
              name="last_name"
              placeholder={I18n.t("pages.user_session.user.last_name")}
              value={this.state.last_name}
              onChange={this.handleInputChange}
              errors={this.state.errors.last_name}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <EmailInput
              name="email"
              placeholder={I18n.t("pages.user_session.user.email")}
              value={this.state.email}
              onChange={this.handleInputChange}
              errors={this.state.errors.email}
            />
          </Col>
          <Col sm={6}>
            <EmailInput
              name="email_confirmation"
              placeholder={I18n.t(
                "pages.user_session.user.email_confirmation"
              )}
              value={this.state.email_confirmation}
              onChange={this.handleInputChange}
              errors={this.state.errors.email_confirmation}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <PasswordInput
              name="password"
              placeholder={I18n.t("pages.user_session.user.password")}
              value={this.state.password}
              onChange={this.handleInputChange}
              errors={this.state.errors.password}
            />
          </Col>
          <Col sm={6}>
            <PasswordInput
              name="password_confirmation"
              placeholder={I18n.t(
                "pages.user_session.user.password_confirmation"
              )}
              value={this.state.password_confirmation}
              onChange={this.handleInputChange}
              errors={this.state.errors.password_confirmation}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6} xs={12}>
            <TextLineInput
              name="inviter_referral_code"
              placeholder={I18n.t("pages.user_session.user.referral_code")}
              value={this.state.inviter_referral_code}
              onChange={this.handleInputChange}
              errors={this.state.errors.inviter_referral_code}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <TermOfServicePreview/>
          </Col>
        </Row>

        <Row>
          <Col sm={12} className="mt-4">
            <PrivacyCustomerPreview/>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <CheckBoxInput
              name="terms_of_service"
              checked={this.state.terms_of_service}
              onChange={this.handleInputChange}
              label={I18n.t("pages.user_session.user.terms_of_service")}
              errors={this.state.errors.terms_of_service}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <CheckBoxInput
              name="marketing"
              checked={this.state.marketing}
              onChange={this.handleInputChange}
              label={I18n.t("pages.user_session.user.marketing")}
              errors={this.state.errors.marketing}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <CheckBoxInput
              name="profiling"
              checked={this.state.profiling}
              onChange={this.handleInputChange}
              label={I18n.t("pages.user_session.user.profiling")}
              errors={this.state.errors.profiling}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6} smPush={3}>
            <SubmitButton
              value={I18n.t("continue")}
              className="sign-user-page-btn btn-blue"
            />
          </Col>
        </Row>
      </form>
    );
  }
}
